export const USER_TYPE_MAP = {
  user: 1,
  driver: 2
};

export const USER_TYPE_ID_MAP = {
  1: 'user',
  2: 'driver'
};

export const TEMPLATE_MODE = {
  SINGLE: 1,
  UNION: 2
};

export const TEMPLATE_NAME = {
  0: '抽奖',
  2: '邀请好友',
  3: '拼团',
  4: '企业积分',
  5: '领券类活动',
  6: '助力领券'
};
